<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        .pull-right.m-t-sm
            button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                :disabled="onLoading('save-supplier')",
                @click="cancel",
            ) Cancel

            button.md-btn.md-raised.m-b-sm.w-xs.green(
                :disabled="onLoading('save-supplier')",
                @click="submit",
            )
                v-loading(loader="save-supplier") Save

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") Supplier
                li.breadcrumb-item.active {{ supplier.name }}
    .padding(v-show="!onLoading('fetch-supplier')")
        .box
            .box-header.dker
                h3 Edit Supplier
            .box-divider.m-a-0
            .box-body
                include supplier-form

        supplier-stock-list(v-if="!onLoading('fetch-supplier')", :supplier-id="supplier.id")
            
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import countries from '@js/data/countries.json';
import supplierStockList from './supplier-stock-list.vue';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: { supplierStockList },

    computed: {
        ...mapGetters('supplier', ['supplier']),
        countries: () => countries,
        country: {
            get() {
                return { name: this.supplier.country };
            },
            set(country) {
                const value = country === null ? null : country.name;
                this.setSupplierAttr({ key: 'country', value });
            },
        },
        loading() {
            return (
                this.onLoading('save-supplier') ||
                this.onLoading('fetch-supplier')
            );
        },
    },

    created() {
        this.getSupplier(this.$route.params.id);
    },

    methods: {
        ...mapActions('supplier', [
            'setSupplierAttr',
            'getSupplier',
            'updateSupplier',
        ]),

        cancel() {
            this.$router.push('/');
        },

        async submit() {
            if (!(await this.$validator.validate())) return;

            try {
                const { data } = await this.updateSupplier();
                this.swal({ text: 'Supplier has successfully updated' });
            } catch (e) {
                this.swalError({ text: e });
                throw e;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/supplier/supplier-edit.vue